import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import '../../../../../../../context/actions.js';
import '../../../../../../../context/reducer.js';
import '../../../../../../../types/product.js';
import '../../../../../../../context/ProductContext.js';
import '../../../../../../../context/CmsContext.js';
import '../../../../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/forms';
import '@grandvisionhq/inventory';
import '../../../../../../../slots/context.js';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/content';
import { WITH_RX, WITHOUT_RX } from '../../../../../components/RxableSelect/contants.js';
import '@grandvisionhq/lib-utils-html';
import { useCLEcommContext } from '../../../../context/CLEcommContext.js';
import { CLRxableSelect } from './CLRxableSelect.js';

const CLRxableSelectContainer = ({ className  })=>{
    const { getLabel  } = useIntl();
    const { actions , state  } = useCLEcommContext();
    const { rxToggle: rxToggle1  } = state.configurations;
    const radioButtonItems = [
        {
            value: WITH_RX,
            label: getLabel('products.selectRxAble.contactLens.withRx')
        },
        {
            value: WITHOUT_RX,
            label: getLabel('products.selectRxAble.contactLens.withoutRx')
        }, 
    ];
    const onRxRadioChange = React.useCallback((rxToggle)=>{
        actions.updateRxToggleSelection(rxToggle);
    }, [
        actions
    ]);
    return /*#__PURE__*/ React.createElement(CLRxableSelect, {
        items: radioButtonItems,
        onChange: onRxRadioChange,
        selectedValue: rxToggle1,
        className: className
    });
};

export { CLRxableSelectContainer };
//# sourceMappingURL=CLRxableSelectContainer.js.map
